(function() {
  'use strict';
  
  // Función para ordenar tallas
  function sortSizes(buttons) {
    return Array.from(buttons).sort((a, b) => {
      const sizeA = a.textContent.trim();
      const sizeB = b.textContent.trim();
      
      // Convertir a números para comparación
      const numA = parseInt(sizeA);
      const numB = parseInt(sizeB);
      
      // Si ambos son números válidos, ordenar numéricamente
      if (!isNaN(numA) && !isNaN(numB)) {
        return numA - numB;
      }
      
      // Definir orden para tallas alfabéticas
      const alphabeticalOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
      const indexA = alphabeticalOrder.indexOf(sizeA.toUpperCase());
      const indexB = alphabeticalOrder.indexOf(sizeB.toUpperCase());
      
      // Si ambos están en el array alfabético
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      
      // Si uno es numérico y otro alfabético, el numérico va primero
      if (!isNaN(numA) && indexB !== -1) return -1;
      if (!isNaN(numB) && indexA !== -1) return 1;
      
      // Si uno es numérico y otro no está en ninguna categoría
      if (!isNaN(numA) && isNaN(numB)) return -1;
      if (!isNaN(numB) && isNaN(numA)) return 1;
      
      // Si uno es alfabético y otro no está en ninguna categoría
      if (indexA !== -1 && indexB === -1) return -1;
      if (indexB !== -1 && indexA === -1) return 1;
      
      // Fallback: orden alfabético
      return sizeA.localeCompare(sizeB);
    });
  }
  
  // Función para reordenar un contenedor específico
  function reorderContainer(container) {
    if (!container || container.dataset.sorted === 'true') return;
    
    const buttons = container.querySelectorAll('.variant-button');
    if (buttons.length <= 1) return;
    
    // Obtener orden actual
    const currentOrder = Array.from(buttons).map(btn => btn.textContent.trim()).join(',');
    
    // Ordenar botones
    const sortedButtons = sortSizes(buttons);
    const newOrder = sortedButtons.map(btn => btn.textContent.trim()).join(',');
    
    // Solo reordenar si hay cambios
    if (currentOrder !== newOrder) {
      console.log('🔄 Reordenando variantes:', currentOrder, '→', newOrder);
      
      // Reordenar en el DOM
      sortedButtons.forEach(button => {
        container.appendChild(button);
      });
      
      // Marcar como ordenado temporalmente
      container.dataset.sorted = 'true';
      setTimeout(() => {
        delete container.dataset.sorted;
      }, 100);
    }
  }
  
  // Función principal que ejecuta el ordenamiento
  function forceVariantSorting() {
    const containers = document.querySelectorAll('.variant-buttons');
    containers.forEach(reorderContainer);
  }
  
  // Ejecutar inmediatamente
  forceVariantSorting();
  
  // Ejecutar cada 500ms para contrarrestar otros scripts
  const sortingInterval = setInterval(forceVariantSorting, 500);
  
  // Observer para nuevos elementos
  const observer = new MutationObserver(function(mutations) {
    let shouldSort = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Verificar si se agregaron nuevos variant-buttons
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if (node.classList?.contains('variant-buttons') || 
                node.querySelector?.('.variant-buttons')) {
              shouldSort = true;
            }
          }
        });
      }
    });
    
    if (shouldSort) {
      setTimeout(forceVariantSorting, 50);
    }
  });
  
  // Observar cambios en todo el documento
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Ejecutar en eventos específicos que podrían cambiar las variantes
  const events = ['DOMContentLoaded', 'load', 'resize', 'scroll'];
  events.forEach(event => {
    window.addEventListener(event, () => {
      setTimeout(forceVariantSorting, 100);
    });
  });
  
  // Hook en fetch para capturar actualizaciones AJAX
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      // Ejecutar ordenamiento después de cualquier fetch
      setTimeout(forceVariantSorting, 200);
      return response;
    });
  };
  
  // Hook en XMLHttpRequest para capturar requests AJAX
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(...args) {
    this.addEventListener('load', () => {
      setTimeout(forceVariantSorting, 200);
    });
    return originalOpen.apply(this, args);
  };
  
  // Función global para forzar manualmente
  window.forceSortVariants = forceVariantSorting;
  
  console.log('✅ Variant sorting forcer activado - ejecutándose cada 500ms');
  
  // Limpieza si es necesario (opcional)
  window.stopVariantSorting = function() {
    clearInterval(sortingInterval);
    observer.disconnect();
    console.log('❌ Variant sorting forcer desactivado');
  };
  
})();